import { Button } from '@mlm/ui';
import { apiErrorMessage } from '../lib/api';

/**
 * A load that failed, said plainly, with a retry. Without it a dropped request
 * reads as data: a ₱0.00 balance, an empty course list, a page stuck on
 * "Loading…" forever.
 */
export function QueryError({
  what,
  error,
  onRetry,
}: {
  /** What did not load, e.g. "your balance". */
  what: string;
  error: unknown;
  onRetry: () => void;
}) {
  return (
    <div
      role="alert"
      className="rounded-lg border border-destructive/30 bg-destructive/5 p-4 text-sm"
    >
      <p className="font-medium text-foreground">Couldn&apos;t load {what}.</p>
      <p className="mt-1 text-muted-foreground">
        {apiErrorMessage(error, 'Check your connection and try again.')}
      </p>
      <Button size="sm" variant="outline" className="mt-3" onClick={onRetry}>
        Try again
      </Button>
    </div>
  );
}
